import { useQuery } from '@tanstack/react-query';

import { fetchPatientPharmaciesByUserId } from '../api/getPatientPharmaciesByUserId.js';
import { rxKeys } from './keys.js';

export function patientPharmaciesQueryDefinition(userId: string) {
  return {
    queryKey: rxKeys.patientPharmacies(userId),
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchPatientPharmaciesByUserId(userId, signal),
    meta: {
      toast: {
        title: 'Could not load patient pharmacies',
        description: 'Patient pharmacies could not be fetched from DoseSpot.',
      },
    },
  } as const;
}

export function usePatientPharmaciesQuery(userId: string | undefined) {
  return useQuery({
    ...patientPharmaciesQueryDefinition(userId ?? ''),
    enabled: !!userId,
  });
}
